import { BaseRenderable } from "./base_renderable"
import { Coordinate, Entity, WeaponCharacteristics } from "game-common/models"

export class Bullet extends BaseRenderable {
    private launchOffset?: Coordinate

    constructor(color: any = 0xff0000, alpha = 1.0,
        private readonly bowOffset?: (entity: Entity) => Coordinate | undefined) {
        super()

        super.beginFill(0xff0000, alpha)
        super.lineStyle(2, 0xff0000, alpha)
        super.drawRoundedRect(5, 0, 9, 1, 1)
        super.endFill()

        super.beginFill(0xffffff, 0.35)
        super.lineStyle(2, 0xffffff, 0.35)
        super.drawRoundedRect(2, 0, 4, 1, 1)
        super.endFill()

        super.beginFill(0xffffff, 0.1)
        super.lineStyle(2, 0xffffff, 0.1)
        super.drawRoundedRect(0, 0, 3, 1, 1)
        super.endFill()
    }

    updateRenderedLocationFrom(entity: Entity) {
        if (!this.launchOffset && entity.spriteId === WeaponCharacteristics.bow.bulletSpriteId) {
            const grip = this.bowOffset?.(entity)
            if (grip) {
                // The simulation starts ahead of the ground origin. Replace that muzzle offset
                // with the visible grip, then keep the same offset throughout the arrow's flight.
                const muzzle = entity.crossFloorProjectile ? 0 : (WeaponCharacteristics.bow.muzzleFireOffset ?? 0) + 1
                this.launchOffset = { x: grip.x - Math.cos(entity.movement.angle) * muzzle,
                    y: grip.y - Math.sin(entity.movement.angle) * muzzle }
            }
        }
        if (!this.launchOffset) return super.updateRenderedLocationFrom(entity)
        this.x = entity.location.x + this.launchOffset.x
        this.y = entity.location.y + this.launchOffset.y
        this.addSidecar(entity)
    }
}
